import { render, staticRenderFns } from "./ordermanagementoutbound.vue?vue&type=template&id=75fab5c5&"
import script from "./ordermanagementoutbound.vue?vue&type=script&lang=ts&"
export * from "./ordermanagementoutbound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ordermanagementoutbound.vue"
export default component.exports